import {
  GET_CONTENT,
  GET_NEWS_AND_EVENT,
  GET_NEWS_AND_EVENTS,
  GET_INSPIRATION_ARTICLES,
  GET_STYLES,
} from '../constants';

const processEntry = (state, entry) => {
  const map = {};

  const addEntry = (state, entry) => {
    // skip if entry if it's a link or if it has already been added
    if (entry.isLink || map[entry.entryId]) return state;

    let newEntries = [];
    const flattenedEntry = Object.keys(entry).reduce((flatteningEntry, key) => {
      const field = flatteningEntry[key];
      if (Array.isArray(field) && field.length !== 0 && field[0].entryId) {
        newEntries = newEntries.concat(field);
        return { ...flatteningEntry, [key]: field.map(item => ({ isEntry: true, entryId: item.entryId })) };
      } else if (typeof field === 'object' && field.entryId) {
        newEntries.push(field);
        return { ...flatteningEntry, [key]: { isEntry: true, entryId: field.entryId } };
      }
      return flatteningEntry;
    }, entry);

    map[entry.entryId] = true;
    let newState = { ...state, [entry.entryId]: flattenedEntry };
    newEntries.forEach(obj => {
      newState = addEntry(newState, obj);
    });

    return newState;
  };

  return addEntry(state, entry);
};

export default (state = {}, action) => {
  if (action.payload && action.payload.data && action.payload.data.error) return state;

  switch (action.type) {
    case `${GET_CONTENT}_PENDING`:
      return state;

    case `${GET_CONTENT}_FULFILLED`: {
      const { data } = action.payload;
      if (Array.isArray(data)) {
        return data.reduce((state, entry) => processEntry(state, entry), state);
      }
      return processEntry(state, data);
    }

    case `${GET_NEWS_AND_EVENT}_FULFILLED`: {
      const { data } = action.payload;
      return processEntry(state, data);
    }

    case `${GET_NEWS_AND_EVENTS}_FULFILLED`: {
      const { data } = action.payload;
      return data.reduce((state, entry) => processEntry(state, entry), state);
    }

    case `${GET_INSPIRATION_ARTICLES}_FULFILLED`: {
      const { data } = action.payload;
      return data.reduce((state, entry) => processEntry(state, entry), state);
    }

    case `${GET_STYLES}_FULFILLED`: {
      const { data } = action.payload;
      return data.reduce((state, entry) => processEntry(state, entry), state);
    }

    case `${GET_CONTENT}_REJECTED`:
      return state;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/entries.js